module.exports = __webpack_public_path__ + "static/media/other-notification-viewed.79c5aba0.svg";